import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCVGjh5kPy3NnsszCR7P8v5tfP4PGk-Vlk",
  authDomain: "ffarena-47fbf.firebaseapp.com",
  projectId: "ffarena-47fbf",
  storageBucket: "ffarena-47fbf.firebasestorage.app",
  messagingSenderId: "165917801475",
  appId: "1:165917801475:web:14033a679443679e192236"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);